import { type ApiError, api } from "@/lib/api";
import type { FriendProfile, PendingRequest } from "@/types";

export async function getFriends(): Promise<{
  data: FriendProfile[] | null;
  error: ApiError | null;
}> {
  return api.get<FriendProfile[]>("/friends");
}

export async function getPendingRequests(): Promise<{
  data: PendingRequest[] | null;
  error: ApiError | null;
}> {
  return api.get<PendingRequest[]>("/friends/requests/pending");
}

export async function sendFriendRequest(addresseeUserId: string) {
  return api.post("/friends/requests", { addresseeUserId });
}

export async function respondToFriendRequest(
  requesterUserId: string,
  status: "accepted" | "declined",
) {
  return api.patch(`/friends/requests/${requesterUserId}`, { status });
}

export async function removeFriend(otherUserId: string) {
  return api.delete(`/friends/${otherUserId}`);
}

export async function searchProfiles(
  query: string,
): Promise<{ data: FriendProfile[] | null; error: ApiError | null }> {
  return api.get<FriendProfile[]>(`/profiles/search/${encodeURIComponent(query)}`);
}
